import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useContentObject } from "../hooks/useContentData";
import { contentFallback } from "../contentDefaults";
import WikiTabPanel from "./wiki/WikiTabPanel";

const ServerInfo = () => {
  const { data: header } = useContentObject("home.server_info", contentFallback("home.server_info"));
  const { data: theme } = useContentObject("theme.branding", contentFallback("theme.branding"));
  const bgUrl = theme?.bg_server_info || theme?.bg_wiki
    || "https://images.unsplash.com/photo-1514539079130-25950c84af65?auto=format&fit=crop&w=1920&q=70";

  return (
    <section className="relative py-28 bg-[#0a0a0d]">
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{ backgroundImage: `url(${bgUrl})`, backgroundSize: "cover", backgroundPosition: "center" }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0d] via-transparent to-[#0a0a0d]" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col items-center text-center mb-12">
          <div className="ornament"><span>{header?.eyebrow || "Server Info · Wiki"}</span></div>
          <h2 className="section-title mt-6">{header?.title || "Toda la Información"}</h2>
          <div className="gold-divider w-40 mt-6" />
          <p className="mt-6 max-w-2xl text-[#b8b3a8]">{header?.subtitle || ""}</p>
          <Link
            to="/wiki"
            className="mt-4 font-display tracking-[0.18em] uppercase text-xs text-[var(--gold,#d4a843)] hover:text-[var(--gold-light,#f5c542)] inline-flex items-center gap-2"
          >
            Ver wiki completa <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>

        <WikiTabPanel
          layout="horizontal"
          searchPlaceholder="Buscar en wiki: rates, enchant, eventos..."
        />
      </div>
    </section>
  );
};

export default ServerInfo;
